import type { OrigenLead as Origen } from '@/lib/types'

interface OriginBadgeProps {
  origen: Origen
}

const origenLabel: Record<Origen, string> = {
  meta_ads: 'Meta Ads',
  web: 'Web',
  referido: 'Referido',
  workana: 'Workana',
  radio_tv: 'Radio/TV',
  chatbot: 'Chatbot',
  booking: 'Booking',
  whatsapp: 'WhatsApp',
  campana_email: 'Campaña Email',
  outbound: 'Outbound',
  otro: 'Otro',
}

export default function OriginBadge({ origen }: OriginBadgeProps) {
  return (
    <span className={`origin-badge origin-badge--${origen}`}>
      {origenLabel[origen] ?? origen}
    </span>
  )
}
